import {
  convertMsToSeconds as h,
  dateFromUnixTimestamp as l,
} from "../../util/date-utils.js";
import { FEED_ANIMATION_DURATION as E } from "../../common/constants.js";
import T from "../../managers/subscription-manager.js";
import r from "../../../shared-lib/logger.js";
export default class Card {
  constructor(t, i, s, h, n, l, e, r, u, E, o, T, I, a, c, N) {
    (this.id = t),
      (this.viewed = i),
      (this.title = s),
      (this.imageUrl = h),
      (this.description = n),
      (this.created = l),
      (this.updated = e),
      (this.categories = r),
      (this.expiresAt = u),
      (this.url = E),
      (this.linkText = o),
      (this.aspectRatio = T),
      (this.extras = I),
      (this.pinned = a),
      (this.dismissible = c),
      (this.clicked = N),
      (this.id = t),
      (this.viewed = i || !1),
      (this.title = s || ""),
      (this.imageUrl = h),
      (this.description = n || ""),
      (this.created = l || null),
      (this.updated = e || null),
      (this.categories = r || []),
      (this.expiresAt = u || null),
      (this.url = E),
      (this.linkText = o),
      null == T
        ? (this.aspectRatio = null)
        : ((T = parseFloat(T.toString())),
          (this.aspectRatio = isNaN(T) ? null : T)),
      (this.extras = I || {}),
      (this.pinned = a || !1),
      (this.dismissible = c || !1),
      (this.dismissed = !1),
      (this.clicked = N || !1),
      (this.isControl = !1),
      (this.test = !1),
      (this.Et = null),
      (this.Tt = null),
      (this.It = null);
  }
  subscribeToClickedEvent(t) {
    return this.St().Nt(t);
  }
  subscribeToDismissedEvent(t) {
    return this.At().Nt(t);
  }
  removeSubscription(t) {
    this.St().removeSubscription(t), this.At().removeSubscription(t);
  }
  removeAllSubscriptions() {
    this.St().removeAllSubscriptions(), this.At().removeAllSubscriptions();
  }
  dismissCard() {
    if (!this.dismissible || this.dismissed) return;
    "function" == typeof this.logCardDismissal && this.logCardDismissal();
    let t = this.T;
    !t && this.id && (t = document.getElementById(this.id)),
      t &&
        ((t.style.height = t.offsetHeight + "px"),
        (t.className = t.className + " ab-hide"),
        setTimeout(function () {
          t &&
            t.parentNode &&
            ((t.style.height = "0"),
            (t.style.margin = "0"),
            setTimeout(function () {
              t && t.parentNode && t.parentNode.removeChild(t);
            }, Card.Dt));
        }, E));
  }
  St() {
    return null == this.Et && (this.Et = new T()), this.Et;
  }
  At() {
    return null == this.Tt && (this.Tt = new T()), this.Tt;
  }
  K() {
    const t = new Date().valueOf();
    return (
      !(null != this.It && t - this.It < Card.Ct) &&
      ((this.It = t), (this.viewed = !0), !0)
    );
  }
  p() {
    (this.viewed = !0), (this.clicked = !0), this.St().Rt();
  }
  N() {
    return (
      !(!this.dismissible || this.dismissed) &&
      ((this.dismissed = !0), this.At().Rt(), !0)
    );
  }
  Lt(t) {
    if (null == t || t[Card._t.ht] !== this.id) return !0;
    if (t[Card._t.Ot]) return !1;
    if (
      null != t[Card._t.nt] &&
      null != this.updated &&
      parseInt(t[Card._t.nt]) < h(this.updated.valueOf())
    )
      return !0;
    if (
      (t[Card._t.et] && !this.viewed && (this.viewed = !0),
      t[Card._t.zt] && !this.clicked && (this.clicked = t[Card._t.zt]),
      null != t[Card._t.rt] && (this.title = t[Card._t.rt]),
      null != t[Card._t.ot] && (this.imageUrl = t[Card._t.ot]),
      null != t[Card._t.ct] && (this.description = t[Card._t.ct]),
      null != t[Card._t.nt])
    ) {
      const i = l(t[Card._t.nt]);
      null != i && (this.updated = i);
    }
    if (null != t[Card._t.lt]) {
      let i;
      (i = t[Card._t.lt] === Card.Mt ? null : l(t[Card._t.lt])),
        (this.expiresAt = i);
    }
    if (
      (null != t[Card._t.URL] && (this.url = t[Card._t.URL]),
      null != t[Card._t.ft] && (this.linkText = t[Card._t.ft]),
      null != t[Card._t.xt])
    ) {
      const i = parseFloat(t[Card._t.xt].toString());
      this.aspectRatio = isNaN(i) ? null : i;
    }
    return (
      null != t[Card._t.bt] && (this.extras = t[Card._t.bt]),
      null != t[Card._t.gt] && (this.pinned = t[Card._t.gt]),
      null != t[Card._t.jt] && (this.dismissible = t[Card._t.jt]),
      null != t[Card._t.kt] && (this.test = t[Card._t.kt]),
      !0
    );
  }
  Y() {
    r.error("Must be implemented in a subclass");
  }
}
(Card.Mt = -1),
  (Card._t = {
    ht: "id",
    et: "v",
    jt: "db",
    Ot: "r",
    nt: "ca",
    gt: "p",
    lt: "ea",
    bt: "e",
    Z: "tp",
    ot: "i",
    rt: "tt",
    ct: "ds",
    URL: "u",
    ft: "dm",
    xt: "ar",
    zt: "cl",
    kt: "t",
  }),
  (Card.it = {
    st: "captioned_image",
    Pt: "text_announcement",
    Ut: "short_news",
    Gt: "banner_image",
    Xt: "control",
  }),
  (Card.tt = {
    ht: "id",
    et: "v",
    jt: "db",
    dt: "cr",
    nt: "ca",
    gt: "p",
    ut: "t",
    lt: "ea",
    bt: "e",
    Z: "tp",
    ot: "i",
    rt: "tt",
    ct: "ds",
    URL: "u",
    ft: "dm",
    xt: "ar",
    zt: "cl",
    kt: "s",
  }),
  (Card.vt = {
    Vt: "ADVERTISING",
    Wt: "ANNOUNCEMENTS",
    wt: "NEWS",
    Ft: "SOCIAL",
  }),
  (Card.Dt = 400),
  (Card.Ct = 1e4);
